import { useEffect, useState } from "react";
import { Star, Check } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export const GoogleRating = () => {
  const { t } = useLang();
  const g = t.dash.googleRating;
  const [rating, setRating] = useState("");
  const [count, setCount] = useState("");
  const [url, setUrl] = useState("");

  useEffect(() => {
    api.get("/google-rating").then((r) => {
      if (r.data.rating) setRating(String(r.data.rating));
      if (r.data.count) setCount(String(r.data.count));
      if (r.data.url) setUrl(r.data.url);
    }).catch(() => {});
  }, []);

  const save = async () => {
    try {
      await api.put("/settings/google-rating", {
        rating: parseFloat(rating) || 0,
        count: parseInt(count) || 0,
        url: url.trim(),
      });
      toast.success(g.saved);
    } catch {
      toast.error(g.failed);
    }
  };

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8 mb-10" data-testid="google-rating-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-2">
        <Star className="w-4 h-4 text-[#FBBC04]" /> {g.title}
      </p>
      <p className="text-xs text-white/40 mb-5">{g.hint}</p>
      <div className="flex flex-wrap gap-3 items-center">
        <input
          value={rating}
          onChange={(e) => setRating(e.target.value)}
          placeholder={g.rating}
          inputMode="decimal"
          data-testid="google-rating-input"
          className="w-28 bg-black/40 border border-white/15 px-3 py-2 text-sm outline-none focus:border-[#FF7900] transition-colors duration-300"
        />
        <input
          value={count}
          onChange={(e) => setCount(e.target.value)}
          placeholder={g.count}
          inputMode="numeric"
          data-testid="google-count-input"
          className="w-32 bg-black/40 border border-white/15 px-3 py-2 text-sm outline-none focus:border-[#FF7900] transition-colors duration-300"
        />
        <input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder={g.url}
          data-testid="google-url-input"
          className="flex-1 min-w-[220px] bg-black/40 border border-white/15 px-3 py-2 text-sm outline-none focus:border-[#FF7900] transition-colors duration-300"
        />
        <button
          onClick={save}
          data-testid="google-rating-save"
          className="inline-flex items-center gap-2 bg-[#FF7900] hover:bg-white hover:text-black text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors duration-300"
        >
          <Check className="w-4 h-4" /> {g.save}
        </button>
      </div>
    </div>
  );
};
